import { render } from "./CheckBalance.vue?vue&type=template&id=2ab06fac"
import script from "./CheckBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckBalance.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Wallet/CheckBalance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ab06fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ab06fac', __exports__)) {
    api.reload('2ab06fac', __exports__)
  }
  
  module.hot.accept("./CheckBalance.vue?vue&type=template&id=2ab06fac", () => {
    api.rerender('2ab06fac', render)
  })

}


export default __exports__